The type of event, i.e. CandidateProfilePurchased. This corresponds to the `Event.typeCode` field in the GraphQL schema.
